import type { ActivityIndicatorProps } from 'react-native';
import { ActivityIndicator, View } from 'react-native';

import { cn } from '../../utils/cn';

type LoadingProps = ActivityIndicatorProps & {
  className?: string;
  testID?: string;
};

const Loading = ({ className, testID, ...restProps }: LoadingProps) => {
  return (
    <View className={cn('flex flex-1 items-center justify-center', className)} testID={testID}>
      <ActivityIndicator size='large' {...restProps} />
    </View>
  );
};

export default Loading;
